"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Strikethrough = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Strikethrough = function Strikethrough() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12V10.5C24 10.0858 23.6642 9.75 23.25 9.75H13.5V3.75H20.25C20.6642 3.75 21 3.41421 21 3V1.5C21 1.08579 20.6642 0.75 20.25 0.75H3.75C3.33579 0.75 3 1.08579 3 1.5V3C3 3.41421 3.33579 3.75 3.75 3.75H10.5V9.75H0.75C0.335786 9.75 0 10.0858 0 10.5V12C0 12.4142 0.335786 12.75 0.75 12.75H23.25C23.6642 12.75 24 12.4142 24 12ZM11.25 23.25C10.8358 23.25 10.5 22.9142 10.5 22.5V15.75H13.5V22.5C13.5 22.9142 13.1642 23.25 12.75 23.25H11.25Z"
  }));
};

exports.Strikethrough = Strikethrough;